export default __webpack_public_path__ + "media/images/icons_fc/project2-f76e149a35089f59fa3d9fe3dbf75528.png";